module.exports = __webpack_public_path__ + "img/logo-non-tax-title.07e7e9e3.png";